import { render, staticRenderFns } from "./OrdersTransport.vue?vue&type=template&id=0d8f4366&"
import script from "./OrdersTransport.vue?vue&type=script&lang=js&"
export * from "./OrdersTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports